import { postRestURL } from "../utils/constants/constants";
import { backendURL } from "../utils/constants/constants";

export async function getNewInfluencers({ companyId, limit, offset }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/newuser?id_company=${companyId}&limit=${limit}&offset=${offset}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN,
                'Prefer': 'count=exact'
            }
        });
        const pagination = response.headers.get('Content-Range');
        const data = await response.json();
        return { data, pagination };
    } catch (e) {
        throw (e);
    }
}


export async function getFeaturedInfluencers({ companyId, limit, offset }) {
    try {
        const response = await fetch(`${postRestURL}/rpc/featured?id_company=${companyId}&limit=${limit}&offset=${offset}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN,
                'Prefer': 'count=exact'
            }
        });
        const pagination = response.headers.get('Content-Range');
        const data = await response.json();
        return { data, pagination };
    } catch (e) {
        throw (e);
    }
}

export async function getAllInfluencers({ companyId, limit, offset }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/allinfluencers?id_company=${companyId}&limit=${limit}&offset=${offset}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN,
                'Prefer': 'count=exact'
            }
        });
        const pagination = response.headers.get('Content-Range');
        const data = await response.json();
        return { data, pagination };
    } catch (e) {
        throw (e);
    }
}

export async function getAllInfluencersFilter({ companyId, query, limit, offset }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/allinfluencersfilter?id_company=${companyId}${query}&limit=${limit}&offset=${offset}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN,
                'Prefer': 'count=exact'
            }
        });
        const pagination = response.headers.get('Content-Range');
        const data = await response.json();
        return { data, pagination };
    } catch (e) {
        throw (e);
    }
}

export async function getServicesByInfluencer({ influencerId }) {

    try {
        const response = await fetch(`${postRestURL}/ratebyservice?influincr=eq.${influencerId}&deleted=eq.0`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getServicesWithNameByInfluencer({ influencerId }) {

    try {
        const response = await fetch(`${postRestURL}/ratebyservice?order=services&deleted=eq.0&rate=neq.0&influincr=eq.${influencerId}&select=rate,influincr,services(name, nombre)`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getInfluencersByRate({ query }) {

    try {
        const response = await fetch(`${postRestURL}/ratebyservice?deleted=eq.0&select=influincr&or=(${query})`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function postServicesPricesByInfluencer({ servicesPrices, token }) {

    try {
        const response = await fetch(`${backendURL}/influencer/saveRates`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(servicesPrices)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function getInfluencerData({ userName }) {
    try {
        const response = await fetch(`${backendURL}/influencer/${userName}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function deleteInfluencerAccount({ token }) {
    try {
        const response = await fetch(`${backendURL}/influencer`, {
            method: 'DELETE',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getCompanyLikeFromInfluencer({ influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/favorite?select=*&influincrid=eq.${influencerId}&deleted=eq.0`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });

        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function postLikeToCompany({ likeBody }) {
    try {
        const response = await fetch(`${postRestURL}/favorite`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            },
            body: JSON.stringify(likeBody)
        });
        return response;
    } catch (e) {
        throw (e);
    }
}

export async function deleteLikeToCompany({ companyId, influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/favorite?companyid=eq.${companyId}&influincrid=eq.${influencerId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });

        return response;
    } catch (e) {
        throw (e);
    }
}

export async function getProductLikeFromInfluencer({ influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/favoriteproduct?select=*&influincrid=eq.${influencerId}&deleted=eq.0`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });

        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function postLikeToProduct({ likeBody }) {
    try {
        const response = await fetch(`${postRestURL}/favoriteproduct`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            },
            body: JSON.stringify(likeBody)
        });
        return response;
    } catch (e) {
        throw (e);
    }
}

export async function deleteLikeToProduct({ productId, influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/favoriteproduct?productid=eq.${productId}&influincrid=eq.${influencerId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });

        return response;
    } catch (e) {
        throw (e);
    }
}

